import {
  Banner,
  useThemeProvider,
  Text,
} from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../utilities/i18n";
import { AntDesign } from "@expo/vector-icons";

export interface WebWarningBannerProps {}

export const WebWarningBanner = ({}: WebWarningBannerProps) => {
  const { t } = useTranslation("sales");
  const { colors } = useThemeProvider();

  return (
    <Banner
      title={t("banner.web_warning.title")}
      status="warning"
      icon={
        <AntDesign
          name="exclamationcircle"
          size={20}
          color={colors.borderWarning}
        />
      }
    >
      <Text>{t("banner.web_warning.title")}</Text>
    </Banner>
  );
};
